export enum ErrorType {
  SYNC_SPACE = 0,
  PLUGINS = 1,
  GENERATED_FORMS = 2,
}

export class PopulateSpaceError extends Error {
  public type: ErrorType;

  constructor(message: string | undefined, type: ErrorType) {
    super(message);
    this.type = type;
  }
}
